import React from "react";
/**
 * Render the navigation dropdowns for the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function DropdownNav(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=DropdownNav.js.map